export { Tag as default } from './Tag';
